import { CacheableDataObject } from './CacheableDataObject';

import store from 'react/redux/store/store';
import * as chatActions from 'react/redux/actions/chat';

export default class UserFriends extends CacheableDataObject {
	beforeConstruct() {
		this.list = new Map();
	}

	has(friendId) {
		return this.list.has(friendId);
	}

	get(friendId) {
		return this.has(friendId) && this.list.get(friendId).friend;
	}

	getOnlineFriendCount() {
		let count = 0;
		for(let [i, friend] of this.list) {
			if(!friend.friend) {
				continue;
			}
			if(friend.is_online && friend.friend.is_friend) {
				count++;
			}
		}
		return count;
	}

	getPendingFriendCount() {
		let count = 0;
		for(let [i, friend] of this.list) {
			if(!friend.friend) {
				continue;
			}
			if(friend.friend.isPending() && friend.friend.waiting_response) {
				count++;
			}
		}
		return count;
	}

	setFriends(friends) {
		this.list = Users.convertCollection(friends);
		const pendingFriendCount = this.getPendingFriendCount();
		store.dispatch(chatActions.pendingFriendRequestsChanged(pendingFriendCount));
	}

	isPending() {
		if(this.is_friend) {
			return false;
		}
		return (this.request_sent || this.waiting_response);
	}

}